<template>
  <!-- 9.成绩查询 -->
  <div>
    <div class="flex-x-center">
      <div class="profile-content">
        <div class="big-box-check">
          <div class="title">成绩查询</div>
          <div class="score-line">
            <el-table :data="tableData">
              <el-table-column prop="title" label="考试科目"> </el-table-column>
              <el-table-column prop="value" label="考试成绩"> </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-x-center agree-sign-next">
      <button class="next-step" @click="$parent.next()">下一步</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      achievement: [{ date: "语文", address: "66", mark: "mark" }],
    };
  },
  props: {
    // 流程
    process_index: 0,
    process: {
      type: Object,
      default() { return {}; },
    },
  },
  computed: {
    tableData() {
      return Array.isArray(this.process.content) ? this.process.content : [];
    }
  }
};
</script>

<style scoped>
.profile-content {
  width: 80%;
}

.title {
  font-size: 17px;
  padding-top: 10px;
  margin-left: 5px;
}
</style>
